import React, { memo, useContext, createContext, useState } from "react";
import { LANG_EN, LANG_DE } from "../utils/translation";

interface ILanguage {
  lang: string;
  translate: typeof LANG_EN | typeof LANG_DE;
}
interface ILanguageProvider {
  language: ILanguage;
  setLanguage: React.Dispatch<React.SetStateAction<ILanguage>>;
}

export const LanguageContext = createContext({} as ILanguageProvider);

export function useSearchContext() {
  return useContext(LanguageContext);
}

function LanguageProvider({ children }) {
  const [language, setLanguage] = useState({
    lang: "en",
    translate: LANG_EN,
  });
  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export default memo(LanguageProvider);
